import React from 'react';
import { SvgIconProps } from '@mui/material';
import {
  DashboardIcon,
  MissionsIcon,
  TableIcon,
  StatisticsIcon,
  QueryStatisticsIcon,
} from '@common/utils/icons/icons';
import RobotIcon from '@common/utils/icons/RobotIcon';
import TrafficRoundedIcon from '@mui/icons-material/TrafficRounded';
import TrendingUpRoundedIcon from '@mui/icons-material/TrendingUpRounded';

export enum FleetDashboardIcon {
  MissionIcon = 'MissionIcon',
  RobotIcon = 'RobotIcon',
  DashboardIcon = 'DashboardIcon',
  TableIcon = 'TableIcon',
  StatisticsIcon = 'StatisticsIcon',
  QueryStatisticsIcon = 'QueryStatisticsIcon',
  HealthChangesIcon = 'HealthChangesIcon',
  PerformanceChangesIcon = 'PerformanceChangesIcon',
}

interface CustomFleetDashboardIconProps extends SvgIconProps {
  icon: FleetDashboardIcon;
}

const CustomFleetDashboardIcon: React.FC<CustomFleetDashboardIconProps> = ({ icon, ...props }) => {
  switch (icon) {
    case FleetDashboardIcon.MissionIcon:
      return <MissionsIcon {...props} />;
    case FleetDashboardIcon.RobotIcon:
      return <RobotIcon {...props} />;
    case FleetDashboardIcon.DashboardIcon:
      return <DashboardIcon {...props} />;
    case FleetDashboardIcon.TableIcon:
      return <TableIcon {...props} />;
    case FleetDashboardIcon.StatisticsIcon:
      return <StatisticsIcon {...props} />;
    case FleetDashboardIcon.QueryStatisticsIcon:
      return <QueryStatisticsIcon {...props} />;
    case FleetDashboardIcon.HealthChangesIcon:
      return <TrafficRoundedIcon {...props} />;
    case FleetDashboardIcon.PerformanceChangesIcon:
      return <TrendingUpRoundedIcon {...props} />;

    default:
      break;
  }

  return null;
};

export default CustomFleetDashboardIcon;
